import React, { Fragment, useCallback, useRef, useState } from 'react';
import {
  EllipsisVerticalIcon,
  EyeIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';
import { Button } from '../../../../../../components/forms/Buttons/Button';
import {
  deleteFormContent,
  patchFormContent,
} from '../../../../../../services/forms/formContentService';
import SimpleLoader from '../../../../../../components/Loader/SimpleLoader';
import { Menu, Switch, Transition } from '@headlessui/react';
import { useFormEdit } from '../../FormEditContext';

export default function ContentFooter({
  content,
  selected,
  setContents,
  setPoints,
  onAddCondition,
}) {
  const pointRefTimer = useRef();
  const [point, setPoint] = useState(content.points);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isRequired, setIsRequired] = useState(content.is_required);
  const { reportError } = useFormEdit();

  // Спиннер — только пока идёт сам запрос: отмена или крестик тоста его
  // не трогают, а ошибка (409 — на вопрос уже отвечали) его снимает.
  const handleDelete = () => {
    toast.dark(
      ({ closeToast }) => (
        <div>
          <div>Удалить вопрос?</div>
          <div className='mt-3 flex justify-center gap-3'>
            <Button
              text={'Да'}
              color='error-solid'
              onClick={() => {
                closeToast();
                setIsDeleting(true);
                deleteFormContent(content.uuid)
                  ?.then(() => {
                    setPoints((prev) => prev - point);
                    setContents((prev) =>
                      prev.filter((e) => e.uuid !== content.uuid),
                    );
                  })
                  ?.catch((err) => {
                    reportError(err, 'Не удалось удалить вопрос');
                  })
                  ?.finally(() => {
                    setIsDeleting(false);
                  });
              }}
            />
            <Button text={'Нет'} className='text-white' onClick={closeToast} />
          </div>
        </div>
      ),
      {
        toastId: `delete-content-${content.uuid}`,
        autoClose: false,
        closeButton: true,
      },
    );
  };

  const saveContent = useCallback(
    (value, field, onFail) => {
      patchFormContent(content.uuid, { [field]: value })?.catch((err) => {
        if (onFail) onFail();
        reportError(err);
      });
    },
    [content.uuid, reportError],
  );

  const debounceSaveData = useCallback(
    (value, field) => {
      if (pointRefTimer.current) {
        clearTimeout(pointRefTimer.current);
      }

      pointRefTimer.current = setTimeout(() => {
        saveContent(value, field);
        setPoints((prev) => prev - point + +value);
        setPoint(value);
        console.log(value);
      }, 1000);
    },
    [point, saveContent, setPoints],
  );

  return (
    <>
      <div
        className={`${
          selected ? 'flex' : 'hidden'
        } flex-row items-center justify-end gap-1`}
      >
        {/* <DocumentDuplicateIcon
                  className='p-2.5 h-11 cursor-pointer hover:bg-slate-100 rounded-full'
                  title={'Dublicate'} // to translate
                  onClick={() => {}}
                /> */}
        {isDeleting ? (
          <div className='relative '>
            <SimpleLoader className='h-10 p-2.5' />
          </div>
        ) : (
          <TrashIcon
            className='h-10 cursor-pointer rounded-full p-2.5 hover:bg-slate-100'
            title={'Delete'} // to translate
            onClick={handleDelete}
          />
        )}
        <div className='h-8 border-l-2' />
        <div className='mx-2 flex flex-row gap-2'>
          <span className='font-bold'>Required</span>

          <Switch
            checked={isRequired}
            className={`${
              isRequired ? 'bg-blue-600' : 'bg-gray-200'
            } relative inline-flex h-6 w-11 items-center rounded-full`}
            onChange={(value) => {
              setIsRequired(value);
              saveContent(value, 'is_required', () => setIsRequired(!value));
            }}
          >
            <span
              className={`${
                isRequired ? 'translate-x-6' : 'translate-x-1'
              } inline-block h-4 w-4 transform rounded-full bg-white transition`}
            />
          </Switch>
        </div>
        <Menu as='div' className='relative'>
          <Menu.Button className='rounded-full hover:bg-slate-100'>
            <EllipsisVerticalIcon className='h-10 p-2.5' />
          </Menu.Button>
          <Transition
            as={Fragment}
            enter='transition ease-out duration-100'
            enterFrom='transform opacity-0 scale-95'
            enterTo='transform opacity-100 scale-100'
            leave='transition ease-in duration-75'
            leaveFrom='transform opacity-100 scale-100'
            leaveTo='transform opacity-0 scale-95'
          >
            <Menu.Items className='ring-black absolute right-0 z-30 mt-1 w-max origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-opacity-5 focus:outline-none'>
              <Menu.Item>
                {({ active }) => (
                  <button
                    className={`${
                      active ? 'bg-gray-100' : ''
                    } flex w-full flex-row items-center gap-2 px-4 py-2 text-left text-sm text-gray-700`}
                    onClick={onAddCondition}
                  >
                    <EyeIcon className='h-4' />
                    Условие показа
                  </button>
                )}
              </Menu.Item>
            </Menu.Items>
          </Transition>
        </Menu>
        {content?.test_type !== 'CONTENT' && (
          <>
            <input
              className='w-10 border-b border-transparent border-b-slate-200 text-center 
              focus:border-transparent focus:border-b-slate-200 focus:ring-0'
              type='number'
              min='0'
              defaultValue={content.points ?? 0}
              onChange={(e) => {
                debounceSaveData(e?.target?.value, 'points');
              }}
            />
            points {/*to translate*/}
          </>
        )}
      </div>
    </>
  );
}
